import { useI18n } from '@hooks/useI18n/useI18n';

export const NoDataAvailable = () => {
  const { translate } = useI18n();

  return <p>{translate('STATUS.NO_DATA_AVAILABLE')}</p>;
};
